import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@repo/http';
export function useDeleteUser() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ()=>axios.delete("/v2/user"),
        onSuccess: ()=>queryClient.invalidateQueries({
                queryKey: [
                    'current-user'
                ]
            })
    });
}
